import { useEffect } from 'react'
import { getCdnEnvPrefix, getCdnHost, CloudResourceType } from '../lib/env-variables'

export const useGlobalCssVariables = () => {
  useEffect(() => {
    setGlobalCssVariables()
  }, [])
}

const setGlobalCssVariables = () => {
  if (!window) {
    return
  }

  try {
    const root = document.documentElement
    const cssVariables = generateGlobalCssVariables()

    Object.entries(cssVariables).forEach(([key, value]) => {
      root.style.setProperty(key, value)
    })
  } catch (error) {
    console.error('Error setting global CSS variables:', error)
  }
}

const generateGlobalCssVariables = () => {
  const cdnHostFormPreviews = getCdnHost(CloudResourceType.FORM_PREVIEWS)
  const cdnHostHelpDesk = getCdnHost(CloudResourceType.HELP_DESK)

  const cdnEnvPrefix = getCdnEnvPrefix()

  return {
    '--url-loader-animation': `url(https://${cdnHostFormPreviews}/animationpreloaders/animation_1.gif)`,
    '--url-web-sprite': `url(https://${cdnHostHelpDesk}/ftdocsign/${cdnEnvPrefix}/images/TitanWeb_Sprite.png)`,
  }
}
